import logo from './logo.svg';
import React, {createContext,useState} from 'react'; 
import axios from 'axios';
import LoginPage from './featured/auth/pages/LoginPage';
import MainMenu from './featured/auth/pages/MainMenuPage';
import ParticleBackground from './shared/components/background/ParticlesEffect';
import VerificationCodePage from './featured/auth/pages/ValidationPage';
import Layout from './featured/auth/pages/Layout';
import { useAuth } from './featured/auth/context/AuthContext';
import EulaModal from './featured/auth/pages/EulaPage';
import { storageService } from './featured/auth/service/storage';
import ChangePasswordPage from './featured/auth/pages/ChangePasswordPage';
import SettingsView from './featured/auth/pages/SettingsPage';
import ChangeEmailPage from './featured/auth/pages/ChangeEmailPage';

export const AuthContext = createContext();


function App() {
  const { sessionId, isVerified ,isEulaAccepted,changepass,stepOneForgotPassword,mfaForgotPass} = useAuth();
  const [currentView, setCurrentView] = useState('dashboard');
  console.log("Change pass",changepass)

    const Pro = () => {
    return (
      <div className="App">
        {/* Desactivado el fondo animado de partículas */}
        {/* <ParticleBackground /> */}
        <header className="App-header">
          {/* 
            ORDEN DE PRIORIDAD:
            1. Si NO hay sesión: mostrar login o flujo de recuperación de contraseña
            2. Si hay sesión pero NO está verificado: mostrar verificación 2FA
            3. Si hay sesión verificado pero NO aceptó EULA: mostrar EULA
            4. Si hay sesión verificado y EULA aceptado: mostrar aplicación principal
          */}
          
          {!sessionId ? (
            // SIN SESIÓN: Login normal o flujo de "olvide contraseña"
            changepass ? (
              <>
                {!stepOneForgotPassword && <LoginPage type={stepOneForgotPassword} />}
                {stepOneForgotPassword && !mfaForgotPass && <VerificationCodePage type={"pass"} />}
                {stepOneForgotPassword && mfaForgotPass && <ChangePasswordPage />}
              </>
            ) : (
              <LoginPage />
            )
          ) : (
            // CON SESIÓN
            !isVerified ? (
              <VerificationCodePage />
            ) : !isEulaAccepted ? (
              <EulaModal />
            ) : (
              <Layout currentView={currentView} onViewChange={setCurrentView}>
                <MainMenu currentView={currentView} />
              </Layout>
            )
          )}
        </header>
      </div>
    );
  };

  const Test = () => {
    return (
      <div className="App">
        <ParticleBackground />
            <ChangeEmailPage/>
      </div>
    )
  }

  return <Pro/>;
}


export default App;
